import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import OfferIcon from "@components/icons/Offer";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { useRootAppStore } from "@hooks";

export default observer(function CustomMessagePreview(props: {
	isMultiOffer?: boolean;
}) {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	if (!rootStore.chatViewStore.sharedBetSlipData) {
		return null;
	}

	const {
		eventCount,
		maxCoefficient,
		dateCreated,
		sportAbrv,
		firstEventName,
	} = rootStore.chatViewStore.sharedBetSlipData;

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/CustomMessagePreview.tsx"}
		>
			<div className="chat__slip">
				<div className="chat__slip__header">
					<OfferIcon
						type="sport"
						sport={sportAbrv}
						className="chat__icon__primary u-icon u-icon--lrg"
					/>
					{props.isMultiOffer && (
						<i className="u-icon u-icon--bb--active u-icon--base"></i>
					)}
					<span className="chat__slip__count">{eventCount}</span>
					<span className="chat__slip__title">{firstEventName}</span>

					<Button
						type="button"
						onClick={() => {
							rootStore.chatViewStore.setSharedBetSlipData(null);
						}}
						iconOnly
						iconClassName="u-icon--sml u-icon--close u-color--brand--primary"
						className="btn--square btn--square--sml btn--primary--inverted u-mar--left--auto"
					/>
				</div>

				<div className="chat__slip__footer">
					<span>
						{t("BET_SLIP.MAX_COEF")}:{" "}
						<strong>{maxCoefficient}</strong>
					</span>
					<span className="u-color--text--tertiary">
						{dateCreated}
					</span>
				</div>
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
